require('./src/styles/global.css');
require('swiper/css');
require('swiper/css/free-mode');
require('swiper/css/pagination');

const React = require('react');
const ForexCopilotChatWidget =
  require('./src/components/ForexCopilotChatWidget').default;

exports.wrapRootElement = ({ element }) => (
  <>
    {element}
    <ForexCopilotChatWidget />
  </>
);

exports.onRouteUpdate = () => {
  // already loaded via gatsby-ssr.js - just ensures it continues to work during client-side navigation
  if (typeof window !== 'undefined' && window.twq) {
    window.twq('config', 'om75o');
  }
};
